// @flow
import * as React from 'react';
import { Box, Text } from 'grommet';
import styled, { ThemeContext } from 'styled-components';

const StyledTitleBox = styled(Box)`
  position: absolute;
  top: 0;
  z-index: 1;
  left: 0;
  right: 0;
`;

type Props = {
    children: React.Node,
};

const PanelTitle = (props: Props) => {
    const { children } = props;
    const theme = React.useContext(ThemeContext);

    return (
        <StyledTitleBox
            background={theme.global.colors.navigation}
            height="56px"
            justify="center"
            flex={{ shrink: 0 }}
        >
            <Text weight={800} margin={{ left: '57px' }}>
                {children}
            </Text>
        </StyledTitleBox>
    );
};

export default PanelTitle;
